import styled from 'styled-components';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  borderRadius,
  BorderRadiusProps,
  color,
  ColorProps,
  compose,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  system,
  typography,
  TypographyProps,
  variant,
} from 'styled-system';

type FlexBoxType =
  | FlexboxProps
  | MarginProps
  | PaddingProps
  | SpaceProps
  | BorderRadiusProps
  | PositionProps
  | LayoutProps
  | ColorProps
  | BackgroundProps
  | BorderProps
  | TypographyProps
  | { textOverflow: string };

const Box = styled.div<FlexBoxType>(
  compose(flexbox, margin, padding, space, borderRadius, position, layout, color, background, border, typography),
  system({
    textOverflow: {
      property: 'textOverflow',
    },
  }),
  variant({
    prop: 'hover',
    variants: {
      shadow: {
        ':hover': {
          boxShadow: '0px 0px 10px 3px rgb(0 0 0 / 40%)',
        },
      },
    },
  }),
  variant({
    prop: 'border',
    variants: {
      shadow: {
        borderRadius: '8px 30px 10px 32px',
        overflow: 'hidden',
      },
    },
  })
);

// export type FlexBoxProps = ComponentProps<typeof FlexBox>;

Box.defaultProps = { display: 'flex', width: '100%', position: 'relative' };
Box.displayName = 'Box';
export default Box;
